import React from 'react';
import { Search } from '../../components/search/Search.tsx';
import SearchHeader from './header.tsx'
import { SearchContextProvider } from '../../contexts/search.tsx';

const SearchPage = () => {
    return (
        <SearchContextProvider>
            <SearchHeader />
            <Search />
        </SearchContextProvider>
    );
};

export default SearchPage;
